import {
  ExportAsyncJob,
  ExportQueryV2 as QueryV2,
} from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export function getJobItemsAbsoluteCounter(
  job: ExportAsyncJob,
  { query, totalForExport }: { query: QueryV2; totalForExport?: number | null },
) {
  const paging = query.paging ?? query.cursorPaging;
  const getOffset = () => {
    if (job.data?.processedItemsCount != null) {
      return job.data.processedItemsCount;
    }

    if (job.data?.pagingMetadata?.offset != null) {
      return Math.max(
        job.data.pagingMetadata.offset - (paging?.limit as number),
        0,
      );
    }

    const iterationsCount = job.data?.iterationsCount ?? 0;
    return Math.max(iterationsCount - 1, 0) * (paging?.limit as number);
  };

  const processedItemsCount = getOffset();
  return totalForExport
    ? Math.min(processedItemsCount, totalForExport)
    : processedItemsCount;
}
